const DYNAMIC_AIRPORT = 'DYN'

const AIRPORT_ALIASES: Record<string, string> = {
  ARN: 'STO',
}

export {
  DYNAMIC_AIRPORT,
  AIRPORT_ALIASES,
}
